export const getTokenExpirationDelay = (token: string): number | null => {
  try {
    const payload = JSON.parse(atob(token?.split('.')[1]))
    if (!payload.exp) return null

    const now = Date.now()
    const expirationTime = payload.exp * 1000
    const delay = expirationTime - now

    return delay > 0 ? delay : 0
  } catch(err) {
    console.error('Token parse error', err)
    return null
  }
}
